module.exports = __webpack_public_path__ + "img/coming-soon-dark.4ae74f22.svg";